import { type FC } from 'react'
import { UpsellBodyLayout } from '../../Common/UpsellBodyLayout'
import { UpsellFeatureItem } from '../../Common/UpsellFeatureItem'
import AccountOpeningPromo from '../../../../assets/images/upsell-account-opening.png'

export const AccountOpeningUpsellBody: FC = () => {
  return (
    <UpsellBodyLayout
      image={<img src={AccountOpeningPromo} alt='Account Opening promo' className='zocks-border-0.5 w-100 object-fit-contain' />}
      heading='Open new accounts using what Zocks already knows about your client'
      description='Prefilled by your AI Assistant, ready for you to review and submit.'
    />
  )
}

export const AccountOpeningUpsellFeatures: FC = () => {
  return (
    <>
      <UpsellFeatureItem title='Prefilled details' description='Your AI Assistant fills in client details from meetings, emails, and connected systems.' />
      <UpsellFeatureItem title='Validation before submission' description="Check every detail against Schwab's requirements to avoid NIGOs." />
      <UpsellFeatureItem
        title='New accounts for any client'
        description='Onboard new clients or open more accounts for the clients you already have.'
        className='mb-3'
      />
    </>
  )
}
